import { useEffect, useState } from "react";
import { useCreateInvite } from "../lib/queries";
import { Loading } from "./Loading";
import { useToast } from "./Toast";
import { hapticImpact } from "../lib/tg";

interface Props {
  role: "trainer" | "parent";
  onClose: () => void;
}

const BOT_USERNAME = "PenguinTeamUkraineBot";

export function InviteSheet({ role, onClose }: Props) {
  const create = useCreateInvite();
  const toast = useToast();
  const [inviteUrl, setInviteUrl] = useState<string | null>(null);
  const [expiresAt, setExpiresAt] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    create.mutateAsync({ role })
      .then((r) => {
        if (cancelled) return;
        setInviteUrl(`https://t.me/${BOT_USERNAME}?start=join_${r.token}`);
        setExpiresAt(r.expires_at);
      })
      .catch((e) => !cancelled && toast.error((e as Error).message));
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  const title = role === "trainer" ? "Запросити тренера" : "Запросити батька";
  const validDays = expiresAt
    ? Math.max(0, Math.ceil((new Date(expiresAt).getTime() - Date.now()) / 86400000))
    : 0;

  const copy = () => {
    if (!inviteUrl) return;
    navigator.clipboard?.writeText(inviteUrl);
    hapticImpact("light");
    toast.success("Скопійовано");
  };

  const shareViaTelegram = () => {
    if (!inviteUrl) return;
    const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(inviteUrl)}`;
    window.Telegram?.WebApp?.openTelegramLink?.(shareUrl) ??
      window.open(shareUrl, "_blank");
  };

  return (
    <div className="fixed inset-0 z-20 bg-black/40 flex items-end" onClick={onClose}>
      <div className="bg-tg-bg w-full rounded-t-2xl p-4 space-y-3" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-lg font-semibold">{title}</h2>
        <p className="text-sm text-tg-hint">
          Надішли це посилання. Хто перейде за ним у Telegram — стане {role === "trainer" ? "тренером" : "батьком"} у цьому клубі. Діє {validDays} {validDays === 1 ? "день" : "днів"}.
        </p>

        {!inviteUrl ? <Loading /> : (
          <div className="card break-all font-mono text-xs">{inviteUrl}</div>
        )}

        <div className="flex gap-2">
          <button className="btn-secondary flex-1" onClick={copy} disabled={!inviteUrl}>
            📋 Копіювати
          </button>
          <button className="btn-primary flex-1" onClick={shareViaTelegram} disabled={!inviteUrl}>
            ↗ Поділитись
          </button>
        </div>

        <button className="btn-secondary w-full" onClick={onClose}>Закрити</button>
      </div>
    </div>
  );
}
